import { render, staticRenderFns } from "./PricePostedUsaDraftEditionWarningPopover.vue?vue&type=template&id=acfea3e4"
import script from "./PricePostedUsaDraftEditionWarningPopover.vue?vue&type=script&lang=js"
export * from "./PricePostedUsaDraftEditionWarningPopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('acfea3e4')) {
      api.createRecord('acfea3e4', component.options)
    } else {
      api.reload('acfea3e4', component.options)
    }
    module.hot.accept("./PricePostedUsaDraftEditionWarningPopover.vue?vue&type=template&id=acfea3e4", function () {
      api.rerender('acfea3e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/price-posting/usa-pro/PricePostedUsaDraftEditionWarningPopover.vue"
export default component.exports